import { render, staticRenderFns } from "./ProxyUser.vue?vue&type=template&id=0cd37dc9&scoped=true&"
import script from "./ProxyUser.vue?vue&type=script&lang=js&"
export * from "./ProxyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd37dc9",
  null
  
)

export default component.exports